<div class="spaceBetween p-container">
  <a title="Me gusta" (click)="changeReaction('LIKE')">
    <ion-icon *ngIf="post.reaction=='LIKE'" size="large" src="../../../assets/icon/svgs/like-color.svg"></ion-icon>
    <ion-icon *ngIf="post.reaction != 'LIKE'" size="large" src="../../../assets/icon/svgs/like.svg"></ion-icon>
  </a>
  <a title="Me encanta" (click)="changeReaction('LOVE')">
    <ion-icon *ngIf="post.reaction=='LOVE'" size="large" src="../../../assets/icon/svgs/love-color.svg"></ion-icon>
    <ion-icon *ngIf="post.reaction=='' || post.reaction != 'LOVE'" size="large" src="../../../assets/icon/svgs/love.svg"></ion-icon>
  </a>
  <a title="Me divierte" (click)="changeReaction('FUN')">
    <ion-icon *ngIf="post.reaction=='FUN'" size="large" src="../../../assets/icon/svgs/fun-color.svg"></ion-icon>
    <ion-icon *ngIf="post.reaction=='' || post.reaction != 'FUN'" size="large" src="../../../assets/icon/svgs/fun.svg"></ion-icon>
  </a>
  <a title="Me entristece" (click)="changeReaction('SAD')">
    <ion-icon *ngIf="post.reaction=='SAD'" size="large" src="../../../assets/icon/svgs/sad-color.svg"></ion-icon>
    <ion-icon *ngIf="post.reaction=='' || post.reaction != 'SAD'" size="large" src="../../../assets/icon/svgs/sad.svg"></ion-icon>
  </a>
  <a title="Me enoja" (click)="changeReaction('ANGRY')">
    <ion-icon *ngIf="post.reaction=='ANGRY'" size="large" src="../../../assets/icon/svgs/anger-color.svg"></ion-icon>
    <ion-icon *ngIf="post.reaction=='' || post.reaction != 'ANGRY'" size="large" src="../../../assets/icon/svgs/anger.svg"></ion-icon>
  </a>
</div>